export const FuelPlanResponseStatus = {
  Ok: "ok",
  NotAvailable: "notAvailable",
  Error: "error",
} as const;
